export default "__VITE_ASSET__CKQlaIow__"